export default "__VITE_ASSET__46yvHnvA__"